import { Link } from 'react-router';

import { BillingPageWrapper } from '@page/billing/billing.page-style';
import { PageTitle } from '@style/pages/page.style';

export const BillingFailedPage = () => {
  return (
    <BillingPageWrapper>
      <PageTitle>Subscription failed</PageTitle>

      <Link to='/account-settings'>Continue</Link>
    </BillingPageWrapper>
  );
};
